/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, Flex, jsx, Button } from 'theme-ui'

import Heading from '~/components/IntlComponents/Heading'
import ContentCallToAction from '~/components/Content/Section/CallToAction'
import { Link } from 'gatsby'
import React, { useEffect } from 'react'

const TextSection = ({
  section: { title, description, children, cta, ctaIsButton, ctaButton },
}) => {
  useEffect(() => {
    if (title === 'Accessibility') {
      const script = document.createElement('script')
      script.defer = true
      script.src =
        'https://a40.usablenet.com/pt/c/statement/goodles/accessibilitystatement.js?l=1'
      document.body.appendChild(script)
    }
  }, [])

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        width: ['90%', '80%'],
        alignItems: 'center',
        margin: 'auto',
        marginTop: ['24px', '24px', '96px'],
        marginBottom: ['24px', '24px', '96px'],
      }}
    >
      {title !== 'Accessibility' ? (
        <>
          <Heading
            as="h2"
            sx={{
              textAlign: 'center',
              variant: ['text.h3', 'text.h3', 'text.h2'],
              marginTop: ['16px', '16px', '36px'],
              marginBottom: ['16px', null, '32px'],
            }}
          >
            {title}
          </Heading>
          {description && (
            <Box
              sx={{
                textAlign: 'left',
                '& p': {
                  maxWidth: ['100%', null, '70%'],
                  margin: 'auto',
                  marginBottom: ['24px', null, '48px'],
                },
                '& ol': {
                  maxWidth: ['100%', null, '75%'],
                  margin: 'auto',
                  marginBottom: ['24px', null, '48px'],
                },
                '& pre': {
                  maxWidth: ['100%', null, '75%'],
                  margin: 'auto',
                  marginBottom: ['24px', null, '48px'],
                },
                '& ul': {
                  maxWidth: ['100%', null, '75%'],
                  margin: 'auto',
                  marginBottom: ['24px', null, '48px'],
                },
                '& li': {
                  ml: '1rem',
                },
                a: {
                  variant: 'text.link',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
          )}

          {children}
          {cta && !ctaIsButton && (
            <ContentCallToAction
              sx={{
                textAlign: 'center',
                border: '1px solid black',
                marginBottom: ['24px', null, '48px'],
              }}
              content={cta}
            />
          )}
          {ctaIsButton && (
            <Button
              sx={{
                alignItems: 'center',
                borderRadius: '8px',
                color: ctaButton.textColor,
                backgroundColor: ctaButton.buttonColor,
                justifyContent: 'center',
                display: 'flex',
                fontSize: ['18px', '20px'],
                height: '50px',
                margin: '20px auto',
                '&:hover': {
                  background: ctaButton.textColor,
                  color: ctaButton.buttonColor,
                },
              }}
              as={Link}
              to={ctaButton.externalLink ?? ctaButton.page.slug}
            >
              {ctaButton.text}
            </Button>
          )}
        </>
      ) : (
        <div
          sx={{
            maxWidth: ['100%', null, '70%'],
            margin: 'auto',
            marginBottom: ['24px', null, '48px'],
          }}
          id="a40AccessibilityStatement"
        ></div>
      )}
    </Flex>
  )
}

TextSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
  collections: PropTypes.arrayOf(PropTypes.shape({})),
  cta: PropTypes.shape({}),
  children: PropTypes.shape({}),
}

export default TextSection
